module.exports = __webpack_public_path__ + "static/media/Character1_Hair.cb9ffee0.svg";